var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonLabelGreenish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 273.246,
    height: 61.435,
    viewBox: "0 0 273.246 61.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ButtonLabel_greenish",
    d: "M26.856,12.235,15.871,38.151,26.856,73.67H275.828l13.289-27.343-9.1-34.092Z",
    transform: "translate(-15.871 -12.235)",
    fill: "#71ac9e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLabelGreenish);
export default __webpack_public_path__ + "static/media/ButtonLabel_greenish.76fb9ec36c0b1a68bf0dc24524025bc1.svg";
export { ForwardRef as ReactComponent };